/**
 * Password visibility toggle
 * Adds the ability to show/hide password fields
 */
class PasswordToggle extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    // Find all password toggle buttons in the document
    const toggleButtons = document.querySelectorAll('.password-toggle');
    
    // Add click event listener to each button
    toggleButtons.forEach(button => {
      button.addEventListener('click', this.togglePasswordVisibility);
    });
  }

  togglePasswordVisibility(event) {
    event.preventDefault();
    
    const button = event.currentTarget;
    const wrapper = button.closest('.password-input-wrapper');
    const passwordInput = wrapper.querySelector('input[type="password"], input[type="text"]');
    
    // Toggle the password field type between "password" and "text"
    if (passwordInput.type === 'password') {
      passwordInput.type = 'text';
      button.classList.add('active');
    } else {
      passwordInput.type = 'password';
      button.classList.remove('active');
    }
  }
}

// Register the custom element
customElements.define('password-toggle', PasswordToggle);

// Initialize password toggle when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  // Create an instance to initialize the functionality
  new PasswordToggle();
});
